import { alpha, createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#4f46e5', dark: '#3730a3', light: '#eef2ff' },
    secondary: { main: '#0f766e' },
    background: { default: '#f6f7fb', paper: '#ffffff' },
    text: { primary: '#172033', secondary: '#667085' },
    divider: '#e7eaf0',
    success: { main: '#15803d' },
    warning: { main: '#b45309' },
    error: { main: '#c2415d' }
  },
  shape: { borderRadius: 14 },
  typography: {
    fontFamily: 'Inter, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    h4: { fontWeight: 750, letterSpacing: '-0.03em' },
    h5: { fontWeight: 720, letterSpacing: '-0.02em' },
    h6: { fontWeight: 700 },
    button: { fontWeight: 650 }
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: { minWidth: 320 },
        '::selection': { backgroundColor: alpha('#4f46e5', 0.18) }
      }
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: {
          borderRadius: 10,
          minHeight: 40,
          paddingLeft: 16,
          paddingRight: 16,
          textTransform: 'none'
        }
      }
    },
    MuiCard: {
      styleOverrides: {
        root: {
          border: '1px solid #e7eaf0',
          boxShadow: '0 8px 28px rgba(15, 23, 42, 0.055)'
        }
      }
    },
    MuiPaper: { styleOverrides: { rounded: { borderRadius: 14 } } },
    MuiTextField: { defaultProps: { size: 'small' } },
    MuiFormControl: { defaultProps: { size: 'small' } },
    MuiOutlinedInput: {
      styleOverrides: {
        root: { borderRadius: 10, backgroundColor: '#fff' },
        notchedOutline: { borderColor: '#dfe3ea' }
      }
    },
    MuiChip: { styleOverrides: { root: { borderRadius: 8, fontWeight: 650 } } },
    MuiTooltip: { styleOverrides: { tooltip: { borderRadius: 8 } } }
  }
});

export default theme;
